(function () {
	'use strict';

	angular
		.module('expo-cupom-digital.configs', [])
		.config(InterceptorConfig);

	/** @ngInject */
	function InterceptorConfig() {

	}
}());